export const routes = {
  home: "/",
  projects: "/projects",
  contact: "/contact",
  about: "/about",
  services: "/services",
  thanks: "/thanks"
};
